import { render, staticRenderFns } from "./XGGoalChart.vue?vue&type=template&id=34d3d094"
import script from "./XGGoalChart.vue?vue&type=script&lang=js"
export * from "./XGGoalChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports